import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface NavigationRequest {
  tab: number;
  searchTerm: string;
  searchType?: string;
}

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private readonly _navigate$ = new Subject<NavigationRequest>();

  readonly navigate$ = this._navigate$.asObservable();

  navigate(request: NavigationRequest): void {
    this._navigate$.next(request);
  }
}
